import React from 'react';
import './ThreeColumnNarrow.scss';
import {
    ThreeColumnNarrowColumn,
    ThreeColumnNarrowColumnProps,
} from './ThreeColumnNarrowColumn';

export interface ThreeColumnNarrowProps {
    columns: [
        ThreeColumnNarrowColumnProps,
        ThreeColumnNarrowColumnProps,
        ThreeColumnNarrowColumnProps
    ];
    theme: `white` | `gray` | `dark`;
    embedded?: boolean;
}

export const ThreeColumnNarrow = (props: ThreeColumnNarrowProps) => {
    if (
        !props.columns ||
        props.columns.length < 3 ||
        !props.columns.every((col) => col.text || col.heading || col.image)
    ) {
        return (
            <p className="kite-container component-error">
                ERROR: Three column narrow -- all three columns must be
                populated.
            </p>
        );
    }

    return (
        <section
            className={`themed-container c--three-column-narrow ${props.theme}`}
        >
            <div
                className={`inner ${
                    props.embedded ? undefined : `kite-container`
                }`}
            >
                {props.columns.map((col, idx) => {
                    col.bg = props.theme;
                    return <ThreeColumnNarrowColumn key={idx} {...col} />;
                })}
            </div>
        </section>
    );
};

//
